"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import DropCurationButton from "@/components/waves/drops/DropCurationButton";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropFooter } from "./footer/WaveLeaderboardDropFooter";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(61);
  const {
    drop,
    onDropClick
  } = t0;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  const getBorderClasses = _temp;
  let t2;
  if ($[2] !== drop || $[3] !== isMobileScreen || $[4] !== onDropClick) {
    t2 = () => {
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_list",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[2] = drop;
    $[3] = isMobileScreen;
    $[4] = onDropClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== drop) {
    t3 = <WaveLeaderboardDropHeader drop={drop} />;
    $[6] = drop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== drop) {
    t4 = <div className="tw-hidden tw-h-8 lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[8] = drop;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== canDelete || $[11] !== drop) {
    t5 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[10] = canDelete;
    $[11] = drop;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div className="tw-hidden tw-h-8 lg:tw-block">{t5}</div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="tw-flex tw-items-center">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-gap-3"><div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t3}{t7}</div></div>;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== drop) {
    t9 = <div className="tw-space-y-2"><div className="tw-ml-14"><WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} /></div></div>;
    $[21] = drop;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== drop) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><WaveLeaderboardDropRaters drop={drop} /><WaveLeaderboardDropFooter drop={drop} /></div>;
    $[23] = drop;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = drop.context_profile_context?.curatable ?? false;
  const t12 = drop.context_profile_context?.curated ?? false;
  let t13;
  if ($[25] !== drop.id || $[26] !== drop.wave.id || $[27] !== t11 || $[28] !== t12) {
    t13 = <DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={t11} isCurated={t12} />;
    $[25] = drop.id;
    $[26] = drop.wave.id;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== canShowVote || $[31] !== drop) {
    t14 = canShowVote && <VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} variant="subtle" />;
    $[30] = canShowVote;
    $[31] = drop;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-border-t-0 @[700px]:tw-pt-0" onClick={_temp2}>{t13}{t14}</div>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t10 || $[37] !== t15) {
    t16 = <div className="tw-inline-flex tw-flex-col tw-justify-between tw-gap-x-2 tw-space-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-space-y-0 sm:tw-ml-14">{t10}{t15}</div>;
    $[36] = t10;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16 || $[40] !== t8 || $[41] !== t9) {
    t17 = <div className="tw-flex tw-flex-col tw-gap-3">{t8}{t9}{t16}</div>;
    $[39] = t16;
    $[40] = t8;
    $[41] = t9;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t17 || $[44] !== touchHandlers) {
    t18 = <div className={getBorderClasses()} {...touchHandlers}>{t17}</div>;
    $[43] = t17;
    $[44] = touchHandlers;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== drop || $[47] !== isMobileScreen || $[48] !== isVotingModalOpen) {
    t19 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[46] = drop;
    $[47] = isMobileScreen;
    $[48] = isVotingModalOpen;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== canDelete || $[51] !== drop || $[52] !== hasTouchScreen || $[53] !== isActive || $[54] !== setIsActive) {
    t20 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[50] = canDelete;
    $[51] = drop;
    $[52] = hasTouchScreen;
    $[53] = isActive;
    $[54] = setIsActive;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t18 || $[57] !== t19 || $[58] !== t2 || $[59] !== t20) {
    t21 = <div onClick={t2} className="tw-group tw-relative tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-@container">{t18}{t19}{t20}</div>;
    $[56] = t18;
    $[57] = t19;
    $[58] = t2;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
};
function _temp() {
  return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
}
function _temp2(e) {
  return e.stopPropagation();
}